const livres = [
    {

        name: "Harry Potter à l'école des sorciers",
        image: "https://books.google.fr/books/content?id=nvijsUyJYR4C&hl=fr&pg=PP1&img=1&zoom=3&bul=1&sig=ACfU3U1GIwLL9lfLEg2p_oKkS_z2WubZNA&w=1280",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateur: "Thomas Taylor",


    },
    {

        name: "Harry Potter et la chambre des secrets",
        image: "https://i.pinimg.com/474x/54/74/9d/54749dc59cb4a94a4407a87b2ee75dfd.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateur: "Cliff Wright",
    },
    {

        name: "Harry Potter et les Reliques de la Mort",
        image: "https://i.pinimg.com/474x/a0/0b/33/a00b337aaee97d2ea5c67d8ae6b2513d.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Mary GrandPré, Jason Cockcroft",
    }
    ,
    {

        name: "Harry Potter et l'Ordre du phénix",
        image: "https://i.pinimg.com/474x/e7/04/be/e704be7695079146aafaca7b2db1780c.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Mary GrandPré, Jason Cockcroft",
    }
    ,
    {

        name: "Harry Potter et le Prisonnier d'azkaban",
        image: "https://i.pinimg.com/474x/99/16/21/99162165660e77431ddab2913eed1fba.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Jim Kay, Mary GrandPré, Cliff Wright"
    }
    ,
    {

        name: "Harry Potter et la Coupe de feu",
        image: "https://i.pinimg.com/474x/54/3d/ec/543deceaa692a2fd04134989ad1075cb.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Mary GrandPré, Jason Cockcroft",
    },
    {

        name: "Harry Potter et le Prince de sang-mêlé",
        image: "https://i.pinimg.com/474x/43/bd/07/43bd07434c50f962eda52626223c603a.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Mary GrandPré, Jason Cockcroft",
    },
    {

        name: "Harry Potter et l'Enfant maudit",
        image: "https://i.pinimg.com/474x/1f/d4/e4/1fd4e41ebc76259166fce4eafe7e0d05.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Mary GrandPré, Jason Cockcroft",
    },
    {

        name: "Harry Potter, la collection compléte",
        image: "https://i.pinimg.com/474x/35/e4/ad/35e4adcf35325cfda4c25d799b0b07e8.jpg",
        autheur: "J.K Rowling",
        Genre: "Roman, Fantasy littéraire, Littérature pour enfants, Fantasy épique",
        illustrateurs: "Mary GrandPré, Jason Cockcroft",
    },
 

];

export default livres
